import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCompanyCommunicationApiService } from './company-communication-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyCommunicationApiService extends GeneratedCompanyCommunicationApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
